module.exports = __webpack_public_path__ + "static/img/top2.5ecf2cc.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/top2.webp
// module id = tyLy
// module chunks = 1